<template>
  <Transition
    enter-active-class="ds-toast-notifier-enter-active"
    enter-from-class="ds-toast-notifier-enter-from"
    enter-to-class="ds-toast-notifier-enter-to"
    leave-active-class="ds-toast-notifier-leave-active"
    leave-from-class="opacity-100"
    leave-to-class="opacity-0"
  >
    <div
      v-if="notifications.length > 0"
      :class="[`ds-toast-notifier`, overlayCssClasses]"
      data-testid="ds-toast-notifier"
    >
      <div
        :class="['ds-toast-notifier-container', { 'top-5': overlayCssClasses }]"
      >
        <DsToast
          v-for="item in notifications"
          :key="item.id"
          :title="item.title"
          :message="item.message"
          :theme-color="item.themeColor"
          :duration="item.duration"
          :enable-close="item.enableClose"
          :component="item.component"
        />
      </div>
    </div>
  </Transition>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import { useDsToastNotifierStore } from "./DsToastNotifierStore";

import DsToast from "./DsToast.vue";

import type { DsToastStoredNotification } from "../../helpers/toast/DsNotifier.types";

const overlayCssClasses = ref("");
const notifications = ref<DsToastStoredNotification[]>([]);

onMounted(() => {
  prepareNotifications();
});

useDsToastNotifierStore().$subscribe(() => {
  prepareNotifications();
});

function setOverlay(overlay: boolean): void {
  if (overlay) {
    overlayCssClasses.value = "ds-toast-notifier-overlay";
    document.body.style.overflow = "hidden";
  } else {
    overlayCssClasses.value = "";
    window.setTimeout(() => {
      document.body.removeAttribute("style");
    }, 200); //time accord to the transition
  }
}

function prepareNotifications() {
  notifications.value = useDsToastNotifierStore().notifications.slice();
  if (notifications.value.length === 0) {
    setOverlay(false);
  } else {
    notifications.value.forEach((notification) => {
      setOverlay(notification.overlay || false);
    });
    notifications.value.reverse();
  }
}
</script>

<style lang="scss" scoped>
.ds-toast-notifier {
  &-enter-active {
    @apply transform ease-out duration-300 transition;
  }

  &-from-class {
    @apply translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2;
  }

  &-enter-to {
    @apply translate-y-0 opacity-100 sm:translate-x-0;
  }

  &-leave-active {
    @apply transition ease-in duration-200;
  }

  &-container {
    @apply fixed bottom-5 right-2.5 sm:right-5 space-y-3;
  }

  &-overlay {
    @apply fixed z-50 inset-0 bg-gray-900 bg-opacity-30 transition-opacity;
  }
}
</style>
